<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-6 truncate">
            Annulus Pressure Records
        </div>

        <form [formGroup]="searchForm">
            <app-table-filter [searchForm]="searchForm" class="text-primary"></app-table-filter>

            <div class="grid grid-cols-2 gap-2">
                <div class="flex justify-start">
                    <div class="w-19 mx-2">
                        <mat-form-field class="w-full">
                            <mat-select formControlName="PageSize">
                                <mat-option [value]="10"> 10 </mat-option>
                                <mat-option [value]="20"> 20 </mat-option>
                                <mat-option [value]="50"> 50 </mat-option>
                                <mat-option [value]="100"> 100 </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <button class="btn btn-outline btn-default dt-download mx-2" (click)="exportToExcel()">
                        <mat-icon class="text-primary hover:text-white"
                            svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                    </button>
                </div>
                <div class="flex justify-end">
                    <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                        Search
                    </button>
                    <button class="btn btn-outline btn-default" (click)="reset()">
                        Reset
                    </button>
                    <button class="btn btn-outline btn-default mx-2 hover:text-white"
                        (click)="setPage({ offset: dt.page.offset})">
                        <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                    </button>
                </div>
            </div>
        </form>

        <div class="overflow-x-auto">
            <ngx-datatable #ngxDatatable class="bootstrap" id="row" [rows]="dt.rows" [columnMode]="dt.column.mode"
                [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [externalPaging]="true"
                [count]="dt.page.totalRecords" [offset]="dt.page.offset" [limit]="dt.page.size" (page)="setPage($event)"
                (sort)="onSort($event)" [scrollbarH]="true">

                <ngx-datatable-column *ngFor="let column of dt.column.header" [name]="column.name"
                    [sortable]="column.props.sortable" [prop]="column.key"
                    [headerClass]="column.props.headerClass" [width]="column.props.width ?? 150">
                    <ng-template let-row="row" ngx-datatable-header-template>
                        <ng-container [ngSwitch]="column.key">
                            <ng-container *ngSwitchCase="'annulus'">
                                <div class="annulus-header">
                                    Annulus Pressure Reading
                                </div>
                                <div class="flex flex-row annulus-body">
                                    <div *ngFor="let child of column.children" class="basis-1/4 child-border">{{ child.name }}</div>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ column.name }}
                            </ng-container>
                        </ng-container>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-row="row" class="annulus-body" ngx-datatable-cell-template>
                        <ng-container [ngSwitch]="column.key">
                            <ng-container *ngSwitchCase="'no'">
                                {{ rowIndex + 1 + (dt.page.size * dt.page.offset) }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'recordDate'">
                                {{ handleFormatDate(row[column.key],false) }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'annulus'">
                                <div class="flex flex-row">
                                    <div *ngFor="let child of column.children" class="basis-1/4">{{ row[child.key] }}</div>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ row[column.key] }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'action'">
                                <div class="flex">
                                    <button class="btn btn-remove-bg px-2" (click)="createAprModal(row)">
                                        <mat-icon [svgIcon]="'heroicons_outline:plus-circle'"></mat-icon>
                                    </button>

                                    <button class="btn btn-remove-bg px-2" (click)="editAprModal(row)">
                                        <mat-icon style="color:#FFC300"
                                            [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                                    </button>

                                    <button class="btn btn-remove-bg px-2" (click)="openHistoricalModal(row)">
                                        <mat-icon [svgIcon]="'heroicons_outline:document-chart-bar'"></mat-icon>
                                    </button>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
    </div>
</div>